import { CustomTable, NakedTable } from "components";
import { useQuery } from "react-query";
import apiService from "services/api";
import { useHistory } from "react-router-dom";
import { useCallback } from "react";
import { Button } from "reactstrap";
import { FiSearch } from "react-icons/fi";
import { CustomTabs } from "components";
import { useMemo } from "react";
import { columns } from "./constants";

const AttendancePage = () => {
    const { data: ftStaff, isLoading: ftLoading } = useQuery("ftStaff", () =>
        apiService.staff
            .get(undefined, { show_deactivated: true })
            .then((staffs) =>
                staffs.filter(
                    (staff) => staff.active && staff.employeeType === "FT"
                )
            )
    );
    const { data: ptStaff, isLoading: ptLoading } = useQuery("ptStaff", () =>
        apiService.staff
            .get(undefined, { show_deactivated: true })
            .then((staffs) =>
                staffs.filter(
                    (staff) => staff.active && staff.employeeType === "PT"
                )
            )
    );
    const history = useHistory();

    const navigateToStaffAttendancePage = useCallback((staff) => {
        history.push("/staff/attendance/" + staff?.id);
    }, []);

    const actions = useCallback(
        (row) => (
            <div className="actions-right">
                <Button
                    color="warning"
                    size="sm"
                    className="btn-icon btn-link edit"
                    onClick={() => navigateToStaffAttendancePage(row)}
                >
                    <FiSearch size={20} />
                </Button>
            </div>
        ),
        []
    );
    const tabs = useMemo(
        () => [
            {
                title: "FT Staff",
                component: () => (
                    <CustomTable
                        data={ftLoading ? [] : ftStaff}
                        columns={columns}
                        actions={actions}
                        defaultPageSize={25}
                        title="Full-Time Employee Attendance"
                    />
                ),
            },
            {
                title: "PT Staff",
                component: () => (
                    <CustomTable
                        data={ptLoading ? [] : ptStaff}
                        columns={columns}
                        actions={actions}
                        defaultPageSize={25}
                        title="Part-Time Employee Attendance"
                    />
                ),
            },
        ],
        [ftStaff, ptStaff]
    );

    return (
        <div className="content">
            <CustomTabs tabs={tabs} />
        </div>
    );
};

export default AttendancePage;
